<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="44" height="44" viewBox="0 0 44 44">
        <defs>
            <circle id="d6cvavoj1a" cx="22" cy="22" r="22"/>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <use fill="#DA4E4E" xlink:href="#d6cvavoj1a"/>
            <text fill="#FFF" font-family="ProximaNova-Bold, Proxima Nova" font-size="26" font-weight="bold">
                <tspan x="19" y="32">!</tspan>
            </text>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'permission-red'
}
</script>
